var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnalyticsi = function SvgAnalyticsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M18.5 3a2.494 2.494 0 0 0-1.454 4.526l-2.137 5.08c-.076-.007-.15-.023-.228-.023a2.5 2.5 0 0 0-1.5.509l-1.893-1.351a2.5 2.5 0 0 0 .134-.768 2.5 2.5 0 1 0-4.281 1.753l-1.414 3.3C5.652 16.016 5.579 16 5.5 16a2.533 2.533 0 1 0 1.609.6l1.362-3.175a2.5 2.5 0 0 0 .447.046 2.47 2.47 0 0 0 1.5-.51l1.892 1.353a2.5 2.5 0 1 0 3.981-1.127L18.474 8h.026a2.5 2.5 0 1 0 0-5m-13 16.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1m3.42-7.527a1 1 0 1 1 1-1 1 1 0 0 1-1 1m5.759 4.11a1 1 0 1 1 1-1 1 1 0 0 1-1 1M18.5 6.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnalyticsi);
export default ForwardRef;